import React, { useMemo } from 'react';

import { MenuLocaleContext } from 'modules/menu/MenuLocaleContext';
import { MenuModuleContextProvider, useMenuModuleContext } from 'modules/menu/context';
import useMenuData from 'modules/menu/useMenuData';
import { useVenueContext } from 'modules/venue/VenueContext';

import PickingRoutePage from './components/PickingRoutePage';

const PickingRoute = () => {
  const { venue } = useMenuModuleContext();
  const { menu } = useMenuData();

  const menuLocaleContext = useMemo(
    () => ({
      country: venue.country,
      primaryLanguage: menu?.primary_language || ('en' as const),
      timezone: venue.timezone,
    }),
    [menu, venue.country, venue.timezone],
  );

  return (
    <MenuLocaleContext.Provider value={menuLocaleContext}>
      <PickingRoutePage venueId={venue.id} menuId={venue.menu} isExperienceFlow={false} />
    </MenuLocaleContext.Provider>
  );
};

const PickingRouteRoot = () => {
  const venue = useVenueContext();

  return (
    <MenuModuleContextProvider value={{ venue }}>
      <PickingRoute />
    </MenuModuleContextProvider>
  );
};
export default PickingRouteRoot;
